import {
  ChangeDetectionStrategy,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  output,
} from '@angular/core'
import { TranslatePipe } from '@ngx-translate/core'
import { BaseModule } from 'shared/base/base.module'

@Component({
  selector: 'app-away-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [BaseModule, TranslatePipe],
  template: `
    <div class="away-dialog__overlay" (click)="close.emit(true)">
      <div
        class="away-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="away-dialog-title"
        (click)="$event.stopPropagation()"
      >
        <div class="away-dialog__header">
          <span class="away-dialog__title" id="away-dialog-title">
            {{ 'shared.lilaraSidebar.awayDialog.title' | translate }}
          </span>
          <button
            type="button"
            class="away-dialog__close"
            [attr.aria-label]="'common.close' | translate"
            (click)="close.emit(true)"
          >
            <lilara-icon icon="xmark" size="small"></lilara-icon>
          </button>
        </div>
        <div class="away-dialog__body">
          {{ 'shared.lilaraSidebar.awayDialog.body' | translate }}
        </div>
        <div class="away-dialog__footer">
          <button type="button" ht-button-secondary (click)="close.emit(true)">
            {{ 'shared.lilaraSidebar.awayDialog.continueInAway' | translate }}
          </button>
          <button type="button" ht-button-primary (click)="close.emit(false)">
            {{ 'shared.lilaraSidebar.awayDialog.turnOffAway' | translate }}
          </button>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .away-dialog__overlay {
        position: fixed;
        inset: 0;
        background: rgba(65, 63, 72, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: var(--lilara-spacing-sm, 12px);
        z-index: 1000;
      }

      .away-dialog {
        background: var(--lilara-surface-floating, #fff);
        border-radius: var(--lilara-surface-floating-radius, 16px);
        box-shadow: var(
          --lilara-shadow-level-2,
          0 4px 16px rgba(0, 0, 0, 0.12)
        );
        width: 534px;
        max-width: 100%;
        display: flex;
        flex-direction: column;
      }

      .away-dialog__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 48px;
        padding: 0 var(--lilara-spacing-sm, 16px);
      }

      .away-dialog__title {
        font-size: var(--lilara-font-size-s, 14px);
        font-weight: var(--lilara-font-weight-bold, 700);
        color: var(--lilara-text-contrast, #262628);
      }

      .away-dialog__close {
        display: flex;
        align-items: center;
        background: none;
        border: none;
        padding: 0;
        cursor: pointer;
        color: var(--lilara-text-subtle, #87878c);
      }

      .away-dialog__body {
        font-size: var(--lilara-font-size-s, 14px);
        color: var(--lilara-text-base, #55555c);
        text-align: center;
        padding: var(--lilara-spacing-m, 16px) var(--lilara-spacing-xl, 24px);
      }

      .away-dialog__footer {
        display: flex;
        justify-content: flex-end;
        gap: var(--lilara-spacing-s, 12px);
        padding: var(--lilara-spacing-sm, 16px);
      }
    `,
  ],
})
export class AwayDialogComponent {
  readonly close = output<boolean>()
}
